import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  EVENT: {
    GET: (skip, query) => ({ skip, query }),
    API: {
      GET: apiResourceActionCreator('eventResult')
    }
  }
})

export const apiAction = (authToken, skip, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}), skip })}`, authToken, action.event.api.get)

function* get({ payload }) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, payload.skip, payload && payload.query))
}

const configuration = {
  name: 'get',
  action: action,
  sagas: get,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      eventsResult: action.payload.eventsResult,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      isLoadingMore: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/event/configurations/get.js